import { AppPermission, PermissionKey } from 'shared/types';

export const PERMISSIONS: Record<PermissionKey, AppPermission> = {
    login: 'belnick.login',
};
